import React from 'react';
import { func,string } from 'prop-types';
import TextInputEventHandler from './TextInputEventHandler';
import RowCounter from './RowCounter';
import TextInput from '../../atoms/TextInput/index';
import TextArea from '../../atoms/TextArea/index';

function TextInputComponent({value,onEnter,onBlur,...props}) {
	return(
		<TextInputEventHandler 
			key={value}
			value={value}
			onEnter={onEnter}
			onBlur={onBlur}
			render={({value,onKeyPress,onChange,onBlur})=>{
				return (
					<TextInput 
						{...props}
						value={value}
						onKeyPress={onKeyPress}
						onChange={onChange}
						onBlur={onBlur}
					/>);
			}} />
	);
}
TextInputComponent.propTypes = {
	value : string,
	onEnter : func,
	onBlur : func,
};

function TextAreaComponent({value,...props}) {
	return(
		<TextInputEventHandler 
			key={value}
			value={value}
			{...props}
			render={(handlerProps,other)=>{
				return <RowCounter 
					{...handlerProps}
					{...other}
					render={({ref,rows,onChange},{value,onKeyPress,onBlur,...other2})=>{
						return (
							<TextArea 
								{...other2}
								ref={ref}
								value={value}
								onKeyPress={onKeyPress}
								onChange={onChange}
								onBlur={onBlur}
								rows={rows}
							/>);
					}}
				/>;
				
			}} />
	);
}
TextAreaComponent.propTypes = {
	value : string,
	onEnter : func,
	onBlur : func,
};
export {TextInputComponent,TextAreaComponent,TextInputEventHandler,RowCounter};

